import React, { Component } from 'react';
import * as firebase from 'firebase';
import MetaTags from 'react-meta-tags';
import scrollToComponent from 'react-scroll-to-component';
import ReactDOM from 'react-dom';
import Login from '../View/Login';
import BG from '../images/table8IconBg.svg';
import '../css/table.css';
import {
  ShareButtons,
  generateShareIcon
} from 'react-share'
const {
  FacebookShareButton,
  GooglePlusShareButton
} = ShareButtons;

const FacebookIcon = generateShareIcon('facebook');
const GooglePlusIcon = generateShareIcon('google');

class Table8 extends Component {
  constructor(props) {
    super(props)
    this.state = {
      send: false,
      loading: false,
      ans1: false,
      ans2: false,
      ans3: false,
      ans4: false,
      ans5: false,
      ans6: false,
      name: '趴趴熊自我診斷',
      totalTest:'',
      url: 'herbalcure.com.tw/Table8',
      thumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable8.jpg?alt=media&token=095f076f-60cd-4263-b217-81b7370f8263',
      fbthumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable8.jpg?alt=media&token=095f076f-60cd-4263-b217-81b7370f8263'
    }
    // this.mouseMove = this.mouseMove.bind(this)
    this.tableBox = this.tableBox.bind(this)
    this.handleChangeAns1 = this.handleChangeAns1.bind(this)
    this.handleChangeAns2 = this.handleChangeAns2.bind(this)
    this.handleChangeAns3 = this.handleChangeAns3.bind(this)
    this.handleChangeAns4 = this.handleChangeAns4.bind(this)
    this.handleChangeAns5 = this.handleChangeAns5.bind(this)
    this.handleChangeAns6 = this.handleChangeAns6.bind(this)
    this.goToTable2 = this.goToTable2.bind(this)
    this.goToTable3 = this.goToTable3.bind(this)
    this.goToTable4 = this.goToTable4.bind(this)
    this.goToTable5 = this.goToTable5.bind(this)
    this.goToTable6 = this.goToTable6.bind(this)
    this.tableSave = this.tableSave.bind(this)
  }
  componentDidMount() {
    window.scrollTo(0,0)
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox)
    firebase.auth().onAuthStateChanged((user) => {
      if(user) {
        tableBox.classList.add('isShow')
        const totalTestTableRef = firebase.database().ref().child('total')
        totalTestTableRef.on('value', snap => {
          this.setState({
            totalTest: snap.val().totalTest
          })
        })
       console.log(this.state.totalTest)
      } else {
        tableBox.classList.remove('isShow')
      }
    })
  }

  tableBox() {
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox)
    firebase.auth().onAuthStateChanged((user) => {
      if(user) {
        tableBox.classList.add('isShow')
        scrollToComponent(tableBox, {
        	offset: -50,
        	align: 'top',
        	duration: 700
        })
      } else {
        tableBox.classList.remove('isShow')
        this.setState({ send: true})
        setTimeout(() => this.setState({ loading: true }), 400);
      }
    })
  }
  goToTable2() {
    const table1 = ReactDOM.findDOMNode(this.refs.table1)
    const table2 = ReactDOM.findDOMNode(this.refs.table2)
    table1.classList.remove('isShow')
    table2.classList.add('isShow')
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox)
    scrollToComponent(tableBox, {
      offset: -50,
      align: 'top',
      duration: 700
    })
  }
  goToTable3() {
    const table2 = ReactDOM.findDOMNode(this.refs.table2)
    const table3 = ReactDOM.findDOMNode(this.refs.table3)
    table2.classList.remove('isShow')
    table3.classList.add('isShow')
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox)
    scrollToComponent(tableBox, {
      offset: -50,
      align: 'top',
      duration: 700
    })
  }
  goToTable4() {
    const table3 = ReactDOM.findDOMNode(this.refs.table3)
    const table4 = ReactDOM.findDOMNode(this.refs.table4)
    table3.classList.remove('isShow')
    table4.classList.add('isShow')
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox)
    scrollToComponent(tableBox, {
      offset: -50,
      align: 'top',
      duration: 700
    })
  }
  goToTable5() {
    const table4 = ReactDOM.findDOMNode(this.refs.table4)
    const table5 = ReactDOM.findDOMNode(this.refs.table5)
    table4.classList.remove('isShow')
    table5.classList.add('isShow')
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox)
    scrollToComponent(tableBox, {
      offset: -50,
      align: 'top',
      duration: 700
    })
  }
  goToTable6() {
    const table5 = ReactDOM.findDOMNode(this.refs.table5)
    const table6 = ReactDOM.findDOMNode(this.refs.table6)
    table5.classList.remove('isShow')
    table6.classList.add('isShow')
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox)
    scrollToComponent(tableBox, {
      offset: -50,
      align: 'top',
      duration: 700
    })
  }
  tableSave(event) {
    event.preventDefault()
    const totalTestTableRef = firebase.database().ref().child('total')
    totalTestTableRef.update({
      totalTest: (this.state.totalTest * 1) + 1
    })
    const userId = firebase.auth().currentUser.uid
    const rootRef = firebase.database().ref('users/').child(userId).child('Answers').push()
    const postId = rootRef.key
    const total = ((this.state.ans1 * 1) + (this.state.ans2 * 1) + (this.state.ans3 * 1) + (this.state.ans4 * 1) + (this.state.ans5 * 1) + (this.state.ans6 * 1))
    if (total < 20) {
      rootRef.update({
        Reviews: '恭喜您，您的活動量足夠，不是「趴趴熊」一族喔！',
        ans: total,
        name: '趴趴熊自我診斷',
        createDate: new Date().toLocaleDateString(),
        createTime: new Date().toLocaleTimeString(),
        id: postId,
        url: 'herbalcure.com.tw/Table8',
        localUrl: '/Table8',
        thumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable8.jpg?alt=media&token=095f076f-60cd-4263-b217-81b7370f8263',
        fbthumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable8.jpg?alt=media&token=095f076f-60cd-4263-b217-81b7370f8263'
      })
    } else if (total < 35) {
      rootRef.update({
        Reviews: '您的「不活動成癮」指數屬於中度風險，建議您趕緊找時間動一動吧！',
        ans: total,
        name: '趴趴熊自我診斷',
        createDate: new Date().toLocaleDateString(),
        createTime: new Date().toLocaleTimeString(),
        id: postId,
        url: 'herbalcure.com.tw/Table8',
        localUrl: '/Table8',
        thumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable8.jpg?alt=media&token=095f076f-60cd-4263-b217-81b7370f8263',
        fbthumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable8.jpg?alt=media&token=095f076f-60cd-4263-b217-81b7370f8263'
      })
    } else if (total < 50) {
      rootRef.update({
        Reviews: '您的「不活動成癮」指數屬於高度風險，應加強身體活體量。可能需要進一步檢測個人體能狀況或者找醫師做運動處方諮詢。',
        ans: total,
        name: '趴趴熊自我診斷',
        createDate: new Date().toLocaleDateString(),
        createTime: new Date().toLocaleTimeString(),
        id: postId,
        url: 'herbalcure.com.tw/Table8',
        localUrl: '/Table8',
        thumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable8.jpg?alt=media&token=095f076f-60cd-4263-b217-81b7370f8263',
        fbthumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable8.jpg?alt=media&token=095f076f-60cd-4263-b217-81b7370f8263'
      })
    } else {
      rootRef.update({
        Reviews: '您屬於「趴趴熊」一族！也可能成為罹患慢性疾病的危險群，建議您請教醫師。',
        ans: total,
        name: '趴趴熊自我診斷',
        createDate: new Date().toLocaleDateString(),
        createTime: new Date().toLocaleTimeString(),
        id: postId,
        url: 'herbalcure.com.tw/Table8',
        localUrl: '/Table8',
        thumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable8.jpg?alt=media&token=095f076f-60cd-4263-b217-81b7370f8263',
        fbthumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable8.jpg?alt=media&token=095f076f-60cd-4263-b217-81b7370f8263'
      })
    }
    window.location = ('/Answer/' + postId);
  }
  handleChangeAns1(event) {
    this.setState({ans1: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.add('is17')
    const toNext1 = ReactDOM.findDOMNode(this.refs.toNext1)
    scrollToComponent(toNext1, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns2(event) {
    this.setState({ans2: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.remove('is17')
    sliderBar.classList.add('is34')
    const toNext2 = ReactDOM.findDOMNode(this.refs.toNext2)
    scrollToComponent(toNext2, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns3(event) {
    this.setState({ans3: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.remove('is34')
    sliderBar.classList.add('is51')
    const toNext3 = ReactDOM.findDOMNode(this.refs.toNext3)
    scrollToComponent(toNext3, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns4(event) {
    this.setState({ans4: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.remove('is51')
    sliderBar.classList.add('is68')
    const toNext4 = ReactDOM.findDOMNode(this.refs.toNext4)
    scrollToComponent(toNext4, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns5(event) {
    this.setState({ans5: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.remove('is68')
    sliderBar.classList.add('is85')
    const toNext5 = ReactDOM.findDOMNode(this.refs.toNext5)
    scrollToComponent(toNext5, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns6(event) {
    this.setState({ans6: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.remove('is85')
    sliderBar.classList.add('is100')
    const toNext6 = ReactDOM.findDOMNode(this.refs.toNext6)
    scrollToComponent(toNext6, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  render(postId) {
    const { loading } = this.state;
    if(loading) {
      return <div style={{display: this.state.send ? 'flex' : 'none', background: '#eeede9',justifyContent: 'center', alignItems:'center'}} >
        <Login />
      </div>
    }
    const nextBtn1 = this.state.ans1
     ? <div className="nextTablebtnDefault" onClick={this.goToTable2}>下一題</div>
     : null
    const nextBtn2 = this.state.ans2
     ? <div className="nextTablebtnDefault" onClick={this.goToTable3}>下一題</div>
     : null
    const nextBtn3 = this.state.ans3
     ? <div className="nextTablebtnDefault" onClick={this.goToTable4}>再接再厲</div>
     : null
    const nextBtn4 = this.state.ans4
     ? <div className="nextTablebtnDefault" onClick={this.goToTable5}>快完成了</div>
     : null
    const nextBtn5 = this.state.ans5
     ? <div className="nextTablebtnDefault" onClick={this.goToTable6}>只剩一題了</div>
     : null
    const nextBtn6 = this.state.ans6
     ? <div className="nextTablebtnDefault" onClick={this.tableSave}>完成!提交吧</div>
     : null
    return (
      <div>
        <MetaTags>
            <title>草學藥事 || {this.state.name}</title>
            <meta id="og-title" property="og:title" content={this.state.name} />
        </MetaTags>
        <div className="animationBox" style={Jeyu.Banner} ref="banner">
         <div className="container">
          <div className="row">
          <div style={Jeyu.Slogan} className="slogan table8">
           <h1>你是趴趴熊一族嗎</h1>
           <h2>規律運動 活力充沛</h2>
           <p className="moileNone">
            上班坐著一整天，下班只想躺在床上好好追劇<br />
            周末無所事事，當一天的沙發馬鈴薯<br />
            發現自己體態越來越臃腫，活力大不如從前...
           </p>
           <span className="tableBtnDefault" onClick={this.tableBox}>開始檢測</span>
           <article className="fbBox">
                  <div className="Demo__some-network">
                     <FacebookShareButton
                       url='https://herbalcure.com.tw/Table8'
                       quote={this.state.name}
                       className="Demo__some-network__share-button">
                       <FacebookIcon
                         size={26}
                         round />
                     </FacebookShareButton>
                   </div>
                   <div className="Demo__some-network">
                     <GooglePlusShareButton
                       url='https://herbalcure.com.tw/Table8'
                       className="Demo__some-network__share-button">
                       <GooglePlusIcon
                         size={26}
                         round />
                     </GooglePlusShareButton>
                   </div>
           </article>
          </div>
          </div>
         </div>
        </div>
        <div className="tableBox table2Height" ref="tableBox" style={Jeyu.tableBox}>
         <div className="container">
          <div className="row">
          <div className="tableFlexBox">
           <div className="mobilePd20">
            <h2>趴趴熊自我診斷</h2>
            <sub>請您根據最近一星期內以來身體與情緒的真正感覺，勾選最符合的一項!</sub>
           </div>
            <div className="sliderBar" ref="sliderBar"></div>
            <section className="">
             <form className="tableForm">
             <div className="table1 isShow" ref="table1">
              <article ref="toNext1">
               <h1>Q1:過去的七天中，您平均一天看電視的時間有多少？</h1>
               <input type="radio" value='2'
                id="ans1"
                checked={this.state.ans1 === '2'}
                onChange={this.handleChangeAns1} />
               <label htmlFor="ans1">0分鐘至60分鐘</label>
               <input type="radio" value='7'
                id="ans2"
                checked={this.state.ans1 === '7'}
                onChange={this.handleChangeAns1} />
               <label htmlFor="ans2">61分鐘至120分鐘</label>
               <input type="radio" value='16'
                id="ans3"
                checked={this.state.ans1 === '16'}
                onChange={this.handleChangeAns1} />
               <label htmlFor="ans3">121分鐘以上</label>
              </article>
               <div>{ nextBtn1 }</div>
              </div>
              <div  className="table2" ref="table2">
              <article ref="toNext2">
               <h1>Q2:過去的七天中，您平均一天坐著不動的時間有多少?</h1>
               <input type="radio" value='4'
                id="ans4"
                checked={this.state.ans2 === '4'}
                onChange={this.handleChangeAns2} />
               <label htmlFor="ans4">5小時以下</label>
               <input type="radio" value='10'
                id="ans5"
                checked={this.state.ans2 === '10'}
                onChange={this.handleChangeAns2} />
               <label htmlFor="ans5">5~7小時</label>
               <input type="radio" value='16'
                id="ans6"
                checked={this.state.ans2 === '16'}
                onChange={this.handleChangeAns2} />
               <label htmlFor="ans6">7小時以上</label>
              </article>
               <div>{ nextBtn2 }</div>
              </div>
              <div className="table3" ref="table3">
              <article ref="toNext3">
               <h1>Q3:過去的七天中，您一共累積花了多少時間在做「費力」(讓您很喘)的身體活動?</h1>
               <input type="radio" value='16'
                id="ans7"
                checked={this.state.ans3 === '16'}
                onChange={this.handleChangeAns3} />
               <label htmlFor="ans7">0分鐘至9分鐘</label>
               <input type="radio" value='10'
                id="ans8"
                checked={this.state.ans3 === '10'}
                onChange={this.handleChangeAns3} />
               <label htmlFor="ans8">10分鐘至59分鐘</label>
               <input type="radio" value='5'
                id="ans9"
                checked={this.state.ans3 === '5'}
                onChange={this.handleChangeAns3} />
               <label htmlFor="ans9">60分鐘至74分鐘</label>
               <input type="radio" value='2'
                id="ans10"
                checked={this.state.ans3 === '0'}
                onChange={this.handleChangeAns3} />
               <label htmlFor="ans10">75分鐘以上</label>
              </article>
               <div>{ nextBtn3 }</div>
              </div>
              <div className="table4" ref="table4">
              <article ref="toNext4">
               <h1>Q4:過去的七天中，您一共累積花了多少時間在做「中等費力」(讓您會喘)的身體活動?</h1>
               <input type="radio" value='16'
                id="ans11"
                checked={this.state.ans4 === '16'}
                onChange={this.handleChangeAns4} />
               <label htmlFor="ans11">0分鐘至29分鐘</label>
               <input type="radio" value='12'
                id="ans12"
                checked={this.state.ans4 === '12'}
                onChange={this.handleChangeAns4} />
               <label htmlFor="ans12">30分鐘至59分鐘</label>
               <input type="radio" value='8'
                id="ans13"
                checked={this.state.ans4 === '8'}
                onChange={this.handleChangeAns4} />
               <label htmlFor="ans13">60分鐘至119分鐘</label>
               <input type="radio" value='2'
                id="ans14"
                checked={this.state.ans4 === '2'}
                onChange={this.handleChangeAns4} />
               <label htmlFor="ans14">120分鐘至149分鐘</label>
               <input type="radio" value='2'
                id="ans15"
                checked={this.state.ans4 === '0'}
                onChange={this.handleChangeAns4} />
               <label htmlFor="ans15">150分鐘以上</label>
              </article>
               <div>{ nextBtn4 }</div>
              </div>
              <div className="table5" ref="table5">
              <article ref="toNext5">
               <h1>Q5:您最近的運動計畫為何?</h1>
               <input type="radio" value='16'
                id="ans16"
                checked={this.state.ans5 === '16'}
                onChange={this.handleChangeAns5} />
               <label htmlFor="ans6">目前沒有從事規律運動，在未來6個月也沒有打算要開始運動</label>
               <input type="radio" value='12'
                id="ans17"
                checked={this.state.ans5 === '12'}
                onChange={this.handleChangeAns5} />
               <label htmlFor="ans17">目前沒有從事規律運動，但有打算要在未來6個月內開始運動</label>
               <input type="radio" value='7'
                id="ans18"
                checked={this.state.ans5 === '7'}
                onChange={this.handleChangeAns5} />
               <label htmlFor="ans18">目前有在運動但沒有規律，在未來1個月內有打算要開始規律運動</label>
               <input type="radio" value='3'
                id="ans19"
                checked={this.state.ans5 === '3'}
                onChange={this.handleChangeAns5} />
               <label htmlFor="ans19">過去的1至5個月內，一直有規律的運動</label>
               <input type="radio" value='2'
                id="ans20"
                checked={this.state.ans5 === '0'}
                onChange={this.handleChangeAns5} />
               <label htmlFor="ans20">過去的6個月內甚至超過6個月，一直都有規律的運動</label>
              </article>
               <div>{ nextBtn5 }</div>
              </div>
              <div className="table5" ref="table5">
              <article ref="toNext6">
               <h1>Q6:您不做運動的原因為「懶散不想運動」?</h1>
               <input type="radio" value='16'
                id="ans21"
                checked={this.state.ans6 === '16'}
                onChange={this.handleChangeAns6} />
               <label htmlFor="ans21">是</label>
               <input type="radio" value='7'
                id="ans22"
                checked={this.state.ans6 === '7'}
                onChange={this.handleChangeAns6} />
               <label htmlFor="ans22">否</label>
              </article>
               <div>{ nextBtn6 }</div>
              </div>
             </form>
            </section>
            </div>
          </div>
         </div>
        </div>
      </div>
    )
  }
}

export default Table8;

const Jeyu = {
  Banner: {
    background: 'url('+BG+') center center/ 120%',
    backgroundRepeat: 'no-repeat',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  Slogan: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: '5px solid #325aaa',
    textAlign: 'center',
    padding: '20px 40px',
    flexDirection: 'column'
  },
  tableBox: {
    background: '#23c6c8'
  }
}



// WEBPACK FOOTER //
// ./src/Tables/table8.js